export default `
  mutation abortCodeGeneration($workflowId: ID!, $boundedContextId: ID!) {
    abortCodeGeneration(workflowId: $workflowId, boundedContextId: $boundedContextId)
  }
`
